import script from "./GradeProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./GradeProgress.vue?vue&type=script&setup=true&lang=js"

import "./GradeProgress.vue?vue&type=style&index=0&id=44111cf0&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/AIDean/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44111cf0"]])

export default __exports__